import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { EVENT_LOGS } from '../store/actionTypes';
import { EventLog, EventLogInput } from './models/eventLogs';

export const eventLogs = createApi({
  reducerPath: EVENT_LOGS,
  baseQuery,
  tagTypes: ['EventLogs'],
  endpoints: builder => ({
    createFreeFormEventLog: builder.mutation<EventLog, EventLogInput>({
      query: variables => ({
        document: gql`
          mutation CreateFreeFormEventLog($eventLogInput: EventLogInput!) {
            createFreeFormEventLog(eventLogInput: $eventLogInput) {
              correlationId
            }
          }
        `,
        variables: { eventLogInput: variables },
      }),
      transformResponse: (response: any) => response?.createFreeFormEventLog,
    }),
    getFreeFormEventLogs: builder.query<
      EventLog,
      { page: number; limit: number; correlationId: string }
    >({
      query: variables => ({
        document: gql`
          query GetFreeFormEventLogs($page: Int, $limit: Int, $correlationId: String!) {
            getFreeFormEventLogs(page: $page, limit: $limit, correlationId: $correlationId) {
              correlationId
              action
              data
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getFreeFormEventLogs,
    }),
    getFreeFormEventLog: builder.query<EventLog, { eventLogId: string }>({
      query: variables => ({
        document: gql`
          query GetFreeFormEventLog($eventLogId: String) {
            getFreeFormEventLog(eventLogId: $eventLogId) {
              correlationId
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getFreeFormEventLog,
    }),
    createClassityEventLog: builder.mutation<EventLog, EventLogInput>({
      query: variables => ({
        document: gql`
          mutation CreateClassityEventLog($eventLogInput: EventLogInput!) {
            createClassityEventLog(eventLogInput: $eventLogInput) {
              correlationId
            }
          }
        `,
        variables: { eventLogInput: variables },
      }),
      transformResponse: (response: any) => response?.createClassityEventLog,
    }),
  }),
});

export const {
  useCreateFreeFormEventLogMutation,
  useGetFreeFormEventLogsQuery,
  useGetFreeFormEventLogQuery,
  useCreateClassityEventLogMutation,
} = eventLogs;
